// extracted by mini-css-extract-plugin
export default {"loader_container":"Loading_loader_container__VY9CX","loader":"Loading_loader__Q2JbH"};